import React from 'react'
import { Box, Button, TextField, Typography, Grid } from '@mui/material'
import { useForm } from 'react-hook-form'
import emailjs from 'emailjs-com'
import './contactForm.css'

const ContactForm = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm()

  const onSubmit = (data) => {
    emailjs
      .send(
        'Kaizen',
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        {
          to_name: 'Pulse Pallets',
          from_name: data.Name,
          company: data.Company || '',
          message: data.Message,
          email: data.Email,
          phone: data.Phone || '',
          postcode: data.Postcode || '',
        },
        process.env.REACT_APP_EMAILJS_USER_ID
      )
      .then(() => {
        alert('Thank you. Your enquiry has been sent.')
        reset()
      })
      .catch((error) => {
        alert('Failed to send message.')
        console.error(error)
      })
  }

  return (
    <Box
      width={1}
      sx={{
        py: { xs: 6, md: 8 },
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <Box className="form-container">
        <Typography
          align="center"
          variant="h4"
          sx={{
            color: '#222023',
            fontWeight: 700,
            mb: 4,
          }}
        >
          Contact Us
        </Typography>

        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={3}>
            {/* LEFT COLUMN */}

            <Grid item xs={12} md={4} container direction="column" spacing={2}>
              <Grid item>
                <TextField
                  fullWidth
                  label="Name"
                  {...register('Name', { required: true })}
                  error={!!errors.Name}
                  helperText={errors.Name ? 'Name is required' : ''}
                  sx={inputStyles}
                />
              </Grid>

              <Grid item>
                <TextField
                  fullWidth
                  label="Company Name"
                  {...register('Company')}
                  sx={inputStyles}
                />
              </Grid>

              <Grid item>
                <TextField
                  fullWidth
                  label="Email Address"
                  type="email"
                  {...register('Email', { required: true })}
                  error={!!errors.Email}
                  helperText={errors.Email ? 'Email is required' : ''}
                  sx={inputStyles}
                />
              </Grid>

              <Grid item>
                <TextField
                  fullWidth
                  label="Phone Number"
                  type="tel"
                  {...register('Phone', { required: true })}
                  error={!!errors.Phone}
                  helperText={errors.Phone ? 'Phone number is required' : ''}
                  sx={inputStyles}
                />
              </Grid>

              <Grid item>
                <TextField
                  fullWidth
                  label="Postcode"
                  {...register('Postcode', { required: true })}
                  error={!!errors.Postcode}
                  helperText={errors.Postcode ? 'Postcode is required' : ''}
                  sx={inputStyles}
                />
              </Grid>
            </Grid>

            {/* RIGHT COLUMN */}

            <Grid item xs={12} md={8}>
              <TextField
                fullWidth
                label="Message / Enquiry"
                multiline
                rows={12}
                {...register('Message', { required: true })}
                error={!!errors.Message}
                helperText={errors.Message ? 'Message is required' : ''}
                sx={inputStyles}
              />
            </Grid>
          </Grid>

          <Box
            sx={{
              mt: 4,
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Button
              type="submit"
              size="large"
              sx={{
                backgroundColor: '#0A9B48',
                color: '#fff',
                minWidth: '220px',
                py: 2,
                px: 4,
                fontSize: '1rem',
                fontWeight: 700,
                letterSpacing: '1px',
                borderRadius: 0,

                '&:hover': {
                  transform: 'translateY(-5px)',
                  borderColor: 'white',
                  border: '1px solid',
                  boxShadow: '0 10px 30px rgba(87,200,77,0.15)',
                  backgroundColor: '#57C84D'
                }
              }}
            >
              SEND ENQUIRY →
            </Button>
          </Box>
        </form>
      </Box>
    </Box>
  )
}

const inputStyles = {
  backgroundColor: '#ffffff',
  borderRadius: '6px',

  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: '#0A9B48',
    },

    '&:hover fieldset': {
      borderColor: '#57C84D',
    },

    '&.Mui-focused fieldset': {
      borderColor: '#57C84D',
    },
  },

  '& label': {
    color: '#222023',
  },

  '& label.Mui-focused': {
    color: '#0A9B48',
  },
}

export default ContactForm